import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayPaymentEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/payment/`
        this.webApi = new WebApi()
    }

    async changePayment (jsonObject) {
        const payment = await this.webApi.post(`${this.url}SaveSum`, jsonObject)
        // console.log('payments:', payments)
        if (payment) {
            if (!payment.status_code) {
                if (!payment.error) {
                    return payment
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${payment.status_code}`)
            }
        }
        return null
    }

    async getAllPayments () {
        const payments = await this.webApi.post(`${this.url}list`, { id: null, page: 1, limit: -1 })
        // console.log('payments:', payments)
        if (payments) {
            if (!payments.status_code) {
                if (!payments.error) {
                    return payments
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${payments.status_code}`)
            }
        }
        return null
    }

    async getCheque (paymentId) {
        const cheque = await this.webApi.post(`${this.url}GetForFiltering`, { id: paymentId })
        if (cheque) {
            if (!cheque.status_code) {
                if (!cheque.error) {
                    return cheque
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${cheque.status_code}`)
            }
        }
        return null
    }

    async getForFiltering () {
        const payments = await this.webApi.get(`${this.url}GetForFiltering`)
        // console.log('payments:', payments)
        if (payments) {
            if (!payments.status_code) {
                if (!payments.error) {
                    return payments
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${payments.status_code}`)
            }
        }
        return null
    }

    async getPayment (jsonObject) {
        const payment = await this.webApi.post(`${this.url}list`, jsonObject)
        // console.log('payments:', payments)
        if (payment) {
            if (!payment.status_code) {
                if (!payment.error) {
                    return payment
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${payment.status_code}`)
            }
        }
        return null
    }

    async getPaymentsByClient (clientId, filter_date, state, pageOptions) {
        const payments = await this.webApi.post(`${this.url}list`,
            {
                client: clientId,
                created: { from: filter_date.from, to: filter_date.to },
                state: state,
                page: pageOptions.page,
                limit: pageOptions.itemsPerPage
})
        // console.log('getPaymentsByClient payments:', payments)
        if (payments) {
            if (!payments.status_code) {
                if (!payments.error) {
                    return payments
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${payments.status_code}`)
            }
        }
        return null
    }

    async resendPaymentForCompleted (paymentId) {
        const result = await this.webApi.post(`${this.url}resend/completed/${paymentId}`)
        // console.log('payments:', payments)
        if (result) {
            if (!result.status_code) {
                if (!result.error) {
                    return result
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${result.status_code}`)
            }
        }
        return { error: true }
    }

    async resendPaymentForCompletedArchive (paymentId) {
        const result = await this.webApi.post(`${this.url}resend/completed/archive/${paymentId}`)
        // console.log('payments:', payments)
        if (result) {
            if (!result.status_code) {
                if (!result.error) {
                    return result
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${result.status_code}`)
            }
        }
        return { error: true }
    }

    async resendPaymentForPs (paymentId) {
        const result = await this.webApi.post(`${this.url}resend/ps/${paymentId}`)
        // console.log('payments:', payments)
        if (result) {
            if (!result.status_code) {
                if (!result.error) {
                    return result
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${result.status_code}`)
            }
        }
        return { error: true }
    }

    // arguments: clientId, pageOptions
    // async getPaymentsByClient2 (clientId, pageOptions) {
    //     const payments = await this.webApi.post(`${this.url}list`, { client: clientId, page: pageOptions.page, limit: pageOptions.itemsPerPage })
    //     console.log('getPaymentsByClient payments:', payments)
    //     if (payments) {
    //         if (!payments.status_code) {
    //             if (!payments.error) {
    //                 return payments
    //             } else {
    //                 return null
    //             }
    //         } else {
    //             console.error(`Ошибка с кодом: ${payments.status_code}`)
    //         }
    //     }
    //     return null
    // }
}
